import { ElementType } from 'react';

import { IconArrowLeft } from '@tabler/icons-react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Link from '../Link';

export interface BackButtonProps {
  /** The page above this one, or a history delta where there is none. */
  href?: string | number;
  /** The icon button to draw, so each header keeps its own styling. */
  button?: ElementType;
}

/** A header's leading back button, absent until given somewhere to go. */
const BackButton = ({ href, button: Button = IconButton }: BackButtonProps) => {
  const navigate = useNavigate();

  if (!href) {
    return null;
  }

  return typeof href === 'number' ? (
    <Button aria-label='Back' onClick={() => navigate(href)}>
      <IconArrowLeft />
    </Button>
  ) : (
    <Link href={href} underline='none' color='inherit'>
      <Button aria-label='Back'>
        <IconArrowLeft />
      </Button>
    </Link>
  );
};

export default BackButton;
